import { Directive, OnDestroy } from "@angular/core";
import { pipe, Subject } from "rxjs";
import { distinctUntilChanged, takeUntil, filter, take } from "rxjs/operators";
@Directive()
export class OnDestroyedDirective implements OnDestroy {
	protected unsubscribeAll: Subject<any>;

	constructor() {
		this.unsubscribeAll = new Subject();
	}

	ngOnDestroy(): void {
		this.unsubscribeAll.next(void 0);
		this.unsubscribeAll.complete();
	}

	distinctAndUnsubscribe(): any {
		return pipe(
			distinctUntilChanged(
				(previous, current) =>
					JSON.stringify(previous) === JSON.stringify(current)
			),
			takeUntil(this.unsubscribeAll)
		);
	}
	distinctAndfilterNullAndUnsubscribe(): any {
		return pipe(
			distinctUntilChanged(
				(previous, current) =>
					JSON.stringify(previous) === JSON.stringify(current)
			),
			filter((value) => !!value),
			takeUntil(this.unsubscribeAll)
		);
	}
	filterNullAndUnsubscribe(): any {
		return pipe(
			filter((value) => !!value),
			takeUntil(this.unsubscribeAll)
		);
	}
	takeOne(): any {
		return pipe(take(1));
	}
	takeOneAndFilterNull(): any {
		return pipe(
			filter((value) => !!value),
			take(1)
		);
	}
}
